function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
import { BoolHelper } from 'invision-core';
export var ExternalBillAdditionalProperties = /*#__PURE__*/_createClass(function ExternalBillAdditionalProperties() {
  _classCallCheck(this, ExternalBillAdditionalProperties);
  this.accountNumberRegex = '';
  this.accountNumberRegexDescription = '';
  this.requireNameOnAccount = false;
  this.requirePhoneNumber = false;
  this.requireBillingAddress = false;
  this.requireAuthorizationChallenge = false;
});
export var PaymentInstrumentTypeAdditionalProperties = /*#__PURE__*/_createClass(function PaymentInstrumentTypeAdditionalProperties() {
  _classCallCheck(this, PaymentInstrumentTypeAdditionalProperties);
  this.canBlocklist = false;
  this.isDirectSource = false;
  this.isShareable = false;
  this.userCreatable = false;
  this.userOrderable = false;
});
export var PaymentInstrumentConfigurationAdditionalProperties = /*#__PURE__*/_createClass(function PaymentInstrumentConfigurationAdditionalProperties() {
  _classCallCheck(this, PaymentInstrumentConfigurationAdditionalProperties);
  this.paymentInstrumentTypeCode = false;
  this.requirePhoneNumber = false;
  this.supportsAutoPay = false;
  this.alertMaxActive = Number.MAX_SAFE_INTEGER;
  this.alertMax = Number.MAX_SAFE_INTEGER;
});
export var ValueTypeEnum = {
  BOOLEAN: 'boolean',
  NUMBER: 'number',
  STRING: 'string'
};
export var AdditionPropertyDescriptor = /*#__PURE__*/_createClass(function AdditionPropertyDescriptor(key, propertyName, valueType) {
  _classCallCheck(this, AdditionPropertyDescriptor);
  this.key = key;
  this.propertyName = propertyName;
  this.valueType = valueType;
});
export var externalBillAdditionalPropertyDescriptors = [new AdditionPropertyDescriptor('account_number_regex', 'accountNumberRegex', ValueTypeEnum.STRING), new AdditionPropertyDescriptor('account_number_regex_description', 'accountNumberRegexDescription', ValueTypeEnum.STRING), new AdditionPropertyDescriptor('require_name_on_account', 'requireNameOnAccount', ValueTypeEnum.BOOLEAN), new AdditionPropertyDescriptor('require_phone_number', 'requirePhoneNumber', ValueTypeEnum.BOOLEAN), new AdditionPropertyDescriptor('require_billing_address', 'requireBillingAddress', ValueTypeEnum.BOOLEAN), new AdditionPropertyDescriptor('require_authorization_challenge', 'requireAuthorizationChallenge', ValueTypeEnum.BOOLEAN)];
export var paymentInstrumentTypeAdditionalPropertyDescriptors = [new AdditionPropertyDescriptor('can_blacklist', 'canBlocklist', ValueTypeEnum.BOOLEAN), new AdditionPropertyDescriptor('is_direct_source', 'isDirectSource', ValueTypeEnum.BOOLEAN), new AdditionPropertyDescriptor('is_shareable', 'isShareable', ValueTypeEnum.BOOLEAN), new AdditionPropertyDescriptor('user_creatable', 'userCreatable', ValueTypeEnum.BOOLEAN), new AdditionPropertyDescriptor('user_orderable', 'userOrderable', ValueTypeEnum.BOOLEAN)];
export var paymentInstrumentConfigurationAdditionalPropertyDescriptors = [new AdditionPropertyDescriptor('payment_instrument_type_code', 'paymentInstrumentTypeCode', ValueTypeEnum.STRING), new AdditionPropertyDescriptor('requires_phone_number', 'requirePhoneNumber', ValueTypeEnum.BOOLEAN), new AdditionPropertyDescriptor('alert_max_active', 'alertMaxActive', ValueTypeEnum.NUMBER), new AdditionPropertyDescriptor('alert_max', 'alertMax', ValueTypeEnum.NUMBER), new AdditionPropertyDescriptor('supports_autopay', 'supportsAutoPay', ValueTypeEnum.BOOLEAN)];

/**
 * Parse additionalProperties values into baseObject,
 * a sample additional properties can be accessed at https://qa6.metadata.ascendon.tv/Codes/SystemId/64c0bb7a-53ec-4130-a2ec-8dc8a024d98f/Type/223
 * @param baseObject
 * @param additionalProperties
 * @param descriptors
 */
export var parseAdditionalProperties = function parseAdditionalProperties(baseObject, additionalProperties, descriptors) {
  var descriptorByKey = descriptors.reduce(function (acc, descriptor) {
    var key = descriptor.key;
    acc[key] = descriptor;
    return acc;
  }, {});
  (additionalProperties || []).forEach(function (prop) {
    var key = prop.Key;
    var descriptor = descriptorByKey[key];
    if (descriptor) {
      var rawValue = prop.Value;
      var type = descriptor.valueType;
      var propName = descriptor.propertyName;
      var defaultValue = baseObject[propName];
      var parsedValue;
      if (type === ValueTypeEnum.BOOLEAN) {
        parsedValue = BoolHelper.getBoolOrDefault(rawValue, defaultValue);
      } else if (type === ValueTypeEnum.NUMBER) {
        parsedValue = parseFloat(rawValue);
      } else if (type === ValueTypeEnum.STRING) {
        parsedValue = rawValue !== null && typeof rawValue !== 'undefined' ? rawValue.toString() : rawValue;
      }
      baseObject[propName] = parsedValue;
    }
  });
  return baseObject;
};